<template>
  <div>
    <s-loader
      v-if="loading"
      class="my-5"
      size="lg"
    />
    <s-table
      v-if="!loading"
      class="configuration__table table"
      local-sorting
      :items="contact"
      :fields="fieldsHandler"
      :busy="loading"
    >
      <template #thead-top>
        <b-tr>
          <b-th
            class="table__cell-contact-name"
            colspan="1"
            rowspan="2"
          >
            {{$t('sensors.configuration-dm2.contact')}}
          </b-th>
          <b-th
            class="table__cell-description"
            colspan="1"
            rowspan="2"
          >
            {{$t('sensors.configuration-dm2.description')}}
          </b-th>
          <b-th
            class="table__cell-active-contact"
            colspan="1"
            rowspan="2"
          >
            {{$t('sensors.configuration-dm2.active-contact')}}
          </b-th>
          <b-th
            class="table__cell-measuring-unit"
            colspan="1"
            rowspan="2"
          >
            {{$t('sensors.configuration-dm2.measuring-unit')}}
          </b-th>
          <b-th
            class="table__cell-current"
            colspan="2"
            rowspan="1"
          >
           {{$t('sensors.configuration-dm2.current')}}
          </b-th>
          <b-th
            class="table__cell-range"
            colspan="2"
            rowspan="1"
          >
            {{$t('sensors.configuration-dm2.range')}}
          </b-th>
          <b-th
            class="table__cell-active-alarm"
            colspan="1"
            rowspan="2"
          >
            {{$t('sensors.configuration-dm2.activate-alarm')}}
          </b-th>
          <b-th
            v-if="$hasUserPermission('PER015')"
            colspan="1"
            rowspan="2">
          </b-th>
        </b-tr>
      </template>

      <template #cell(activeContact)="data">
        <span class="table__active-contact material-icons">
          {{ activeContactCheckbox(data.item.registerStatus) }}
        </span>
      </template>
      <template #cell(description)="data">
        {{ data.item.description }}
      </template>
      <template #cell(activateAlarm)="data">
        <span
          v-if="isContactActive(data.item.registerStatus)"
          class="material-icons"
          :class="activeAlarmIcon(data.item.activateAlarm).class"
        >
          {{ activeAlarmIcon(data.item.activateAlarm).value }}
        </span>
      </template>
      <template #cell(actions)="data">
        <b-button
          v-if="hasSupervisorPermission"
          class="table__button-edit"
          variant="outline-primary"
          size="sm"
          @click="editContact(data.item)"
        >
          <s-icon name="edit"/>
          {{ $t('actions.edit') }}
        </b-button>
      </template>
    </s-table>
  </div>
</template>

<script>
import configurationFields from '@/domain/data/installation/supervision/sensors/configurationDM2/configurationFields';
import { InstallationStatus } from 'sigma-mappings';

export default {
  props: {
    contact: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },
  methods: {
    editContact(data) {
      this.$emit('edit-contact', data);
    },
    isContactActive(registerStatus) {
      return registerStatus === InstallationStatus.ACTIVE;
    },
    activeContactCheckbox(registerStatus) {
      const isItActive = this.isContactActive(registerStatus);
      return isItActive ? 'check_box' : 'check_box_outline_blank';
    },
    activeAlarmIcon(activateAlarm) {
      const active = { value: 'visibility', class: 'table__cell-item-active-alarm' };
      const inactive = { value: 'visibility_off', class: 'table__cell-item-active-alarm--inactive' };
      return activateAlarm ? active : inactive;
    },
  },
  computed: {
    fields() {
      return configurationFields(this);
    },
    fieldsHandler() {
      return this.hasSupervisorPermission ? this.supervisorFields : this.fields;
    },
    hasSupervisorPermission() {
      return this.$hasUserPermission('PER015');
    },
    supervisorFields() {
      return [
        ...this.fields,
        {
          key: 'actions',
          class: 'table__cell-actions',
          sortable: false,
          label: '',
          thStyle: {
              display: 'none',
          },
        },
      ];
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"

.material-icons
  color: var(--font-color-secondary)
  vertical-align: middle

::v-deep
  .table__cell
    &-active-contact
      white-space: normal !important
    &-measuring-unit
      white-space: normal !important
    &-active-alarm
      width: 50px
      white-space: normal !important
    &-active-alarm:last-child
      text-align: center !important
    &-description
      max-width: 300px
      min-width: 250px
      text-align: center !important
      word-break: break-all
    &-current:is(th)
      padding: .75rem 4rem
      padding-bottom: 0
    &-range:is(th)
      padding: .75rem 4rem
      padding-bottom: 0
    &-contact-name
      text-align: center !important
    &-min-current:is(th)
      padding-top: 0
    &-max-current:is(th)
      padding-top: 0
    &-min-range:is(th)
      padding-top: 0
    &-max-range:is(th)
      padding-top: 0

.table
  &__button-edit
    white-space: nowrap
  &__cell-item-active-alarm
    color: var(--font-color-secondary)
    &--inactive
      color: var(--font-color-tertiary)

@media print
  ::v-deep
    .table *
      font-size: 14px !important
    .table__cell
      &-current
        padding: 10px 56px
      &-range
        padding: 10px 56px
      &-actions
        display: none
</style>
